import React from 'react';

import {Typography, Grid, Stack} from 'views/components';
import {Translate} from 'views/module';

const LoginInfo = () => {
  return (
    <Grid container
      justifyContent="center"
      sx={{
        pt: {xs: '16px'},
        px: {md: '0px', xs: '16px'},
        width: {md: '540px', sm: '80%', sx: '90%'},
        margin: 'auto',
      }}

    >
      <Grid container
        justifyContent="center"
        sx={{
          pt: {xl: '254px', md: '200px', xs: '16px'},
          px: {md: '0px', xs: '16px'},
          width: {md: '520px', sm: '80%', sx: '90%'},
          margin: 'auto',
        }}>
        <Grid item xs={12} sx={{pb: {lg: '120px', xs: '16px'}}} >
          <Stack direction={'row'}>
            <Typography
              variant='h3'
              sx={{
                color: 'color.white',
              }}
            >
              <Translate expression='auth.Info.Title' />
            </Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} sx={{pb: {lg: '40px', xs: '16px'}}}>
          <Typography
            variant='body2'
            sx={{
              color: 'color.white',

              a: {
                color: 'color.white',
              },
            }}
          >
            <Translate expression='auth.Info.Book' />
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default React.memo(LoginInfo);
